import React from 'react'

function About() {
  return (
    <div>About Us Page</div>
  )
}

export default About